export default __webpack_public_path__ + "static/media/topping.efb179a4.svg";